export const EVENT_TYPES = {
  MILESTONE: "milestone_event",
  SCHEDULED_MATCH: "scheduled_match_event",
};

export const CLOSED_UPCOMING_EVENT_STATUSES = new Set([
  "complete",
  "completed",
  "cancelled",
  "forfeit_no_show",
  "ended_pending_winners",
  "draft",
  "archived",
]);

const normalizeString = (value) => String(value || "").trim().toLowerCase();

export const toEventMillis = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (value instanceof Date) return value.getTime();
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (typeof value?.seconds === "number") {
    return value.seconds * 1000 + Math.floor(Number(value.nanoseconds || 0) / 1e6);
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return 0;
    const numeric = Number(trimmed);
    if (Number.isFinite(numeric) && /^\d+(\.\d+)?$/.test(trimmed)) {
      return numeric;
    }
    const parsed = new Date(trimmed).getTime();
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
};

export const isMilestoneEvent = (event) => {
  const type = normalizeString(event?.type);
  if (type === EVENT_TYPES.MILESTONE) return true;
  if (type === EVENT_TYPES.SCHEDULED_MATCH) return false;
  if (type.includes("milestone") || type.includes("campaign")) return true;

  const hasMilestoneWindow =
    !!(event?.startAt || event?.startMs) && !!(event?.endAt || event?.endMs);
  return hasMilestoneWindow;
};

export const getEventType = (event) =>
  isMilestoneEvent(event) ? EVENT_TYPES.MILESTONE : EVENT_TYPES.SCHEDULED_MATCH;

export const getEventStartMs = (event) =>
  isMilestoneEvent(event)
    ? toEventMillis(event?.startMs ?? event?.startAt)
    : toEventMillis(event?.scheduledStartMs ?? event?.scheduledStartAt);

export const getEventEndMs = (event) =>
  isMilestoneEvent(event) ? toEventMillis(event?.endMs ?? event?.endAt) : 0;

export const isUpcomingEventClosed = (event) =>
  CLOSED_UPCOMING_EVENT_STATUSES.has(normalizeString(event?.status || "scheduled"));

export const isMilestoneEventActiveNow = (event, nowMs = Date.now()) => {
  if (!isMilestoneEvent(event) || isUpcomingEventClosed(event)) return false;

  const status = normalizeString(event?.status || "scheduled");
  if (status === "ongoing") return true;

  const startMs = getEventStartMs(event);
  const endMs = getEventEndMs(event);
  if (!startMs || !endMs) return false;

  return nowMs >= startMs && nowMs < endMs;
};

export const isEventVisibleInUpcomingBadge = (
  event,
  nowMs = Date.now(),
  recentWindowMs = 15 * 60 * 1000,
) => {
  if (isUpcomingEventClosed(event)) return false;
  if (isMilestoneEvent(event)) return isMilestoneEventActiveNow(event, nowMs);

  const startMs = getEventStartMs(event);
  if (!startMs) return false;

  return startMs >= nowMs - recentWindowMs;
};
